import { defineMessages } from 'react-intl';

export default defineMessages({
  requestAccessToCompass: {
    id: 'frontbucket.dashboard.overview.compassBanner.getCompassFree',
    description: 'Get Compass free button text',
    defaultMessage: 'Get Compass free',
  },
  requestAccessToCompassNonAdmin: {
    id: 'frontbucket.dashboard.overview.compassBanner.getCompassFreeNonAdmin',
    description: 'Request access to Compass button text',
    defaultMessage: 'Request access to Compass',
  },
  learnMore: {
    id: 'frontbucket.dashboard.overview.compassBanner.learnMore',
    description: 'Learn more button text',
    defaultMessage: 'Learn more',
  },
  bannerHeading: {
    id: 'frontbucket.dashboard.overview.compassBanner.bannerHeading',
    description: 'Banner heading text',
    defaultMessage: 'Bring more context to your code',
  },
  bannerDescription: {
    id: 'frontbucket.dashboard.overview.compassBanner.bannerDescription',
    description: 'Banner description text',
    defaultMessage:
      'See owners, dependencies, and help resources for your repositories by linking them to a central software catalog.',
  },
  notInterested: {
    id: 'frontbucket.dashboard.overview.compassBanner.notInterested',
    description: 'Not interested text - to dismiss banner',
    defaultMessage: 'Not interested',
  },
  dismissedFlagHeading: {
    id: 'frontbucket.dashboard.overview.compassBanner.dismissedFlagHeading',
    description: 'Heading for flag shown after the banner is dismissed/hidden',
    defaultMessage: 'Thanks for letting us know',
  },
  dismissedFlagDescription: {
    id: 'frontbucket.dashboard.overview.compassBanner.dismissedFlagDescription',
    description:
      'Description for flag shown after the banner is dismissed/hidden',
    defaultMessage: 'You won’t see this ad here again.',
  },
  whyAmISeeingThis: {
    id: 'frontbucket.dashboard.overview.compassBanner.whyAmISeeingThis',
    description: 'Why am I seeing this - text - used in dropdown and modal',
    defaultMessage: 'Why am I seeing this?',
  },
  whyAmISeeingThisModalDescription1: {
    id: 'frontbucket.dashboard.overview.compassBanner.whyAmISeeingThisModalDescription1',
    description: 'Why am I seeing this - modal description part 1',
    defaultMessage:
      'We think connecting Bitbucket to Compass will improve your team’s development experience.',
  },
  whyAmISeeingThisModalDescription2: {
    id: 'frontbucket.dashboard.overview.compassBanner.whyAmISeeingThisModalDescription2',
    description: 'Why am I seeing this - modal description part 2',
    defaultMessage:
      'You can automatically catalog your software architecture in a single place, enrich it with information from across your toolchain, and show relevant information back in Bitbucket.',
  },
  whyAmISeeingThisModalLearnMoreLink: {
    id: 'frontbucket.dashboard.overview.compassBanner.whyAmISeeingThisModalLearnMoreLink',
    description: 'Why am I seeing this - modal learn more link',
    defaultMessage: 'Learn more about your data privacy with Atlassian',
  },
  whyAmISeeingThisModalOkButton: {
    id: 'frontbucket.dashboard.overview.compassBanner.whyAmISeeingThisModalOkButton',
    description: 'Why am I seeing this - modal OK button',
    defaultMessage: 'OK',
  },
  accessRequestSentHeading: {
    id: 'frontbucket.dashboard.overview.compassBanner.accessRequestSentHeading',
    description: 'Header for the request access flag',
    defaultMessage: 'Access request sent',
  },
  accessRequestSentDescription: {
    id: 'frontbucket.dashboard.overview.compassBanner.accessRequestSentDescription',
    description: 'Description for the request access flag',
    defaultMessage: 'We’ve let your Bitbucket admin know.',
  },
  cardHeading: {
    id: 'frontbucket.dashboard.overview.compassBanner.cardHeading',
    description: 'Card heading text',
    defaultMessage: 'Bring more context to your code using Compass',
  },
  cardMenu: {
    id: 'frontbucket.dashboard.overview.compassBanner.cardMenu',
    description: 'Card menu',
    defaultMessage: 'Menu',
  },
});
